import { FileArrowDown, Lightbulb } from '@phosphor-icons/react';
import { EXPORT_GUIDES } from '../data/export_guides';

// "Step 0" — pair-aware guide showing exactly where the export button is
// in the visitor's source CRM. Reacts to the hero dropdown / pairConfig.
export default function ExportGuideSection({ sourceId }) {
  const guide = EXPORT_GUIDES[sourceId] || EXPORT_GUIDES.generic;

  return (
    <section className="px-6 py-16 border-t border-white/10 bg-white/[0.02]" data-testid="mc-export-guide-section">
      <div className="max-w-5xl mx-auto">
        <p className="text-[#F39C12] text-xs font-black uppercase tracking-[0.2em] text-center mb-2">
          Step 0 — before you upload
        </p>
        <h2 className="text-3xl font-black text-center mb-3" data-testid="mc-export-guide-headline">
          How to get your data out of <span className="text-[#F39C12]">{guide.name}</span>
        </h2>
        <p className="text-sm text-white/60 text-center max-w-xl mx-auto mb-10">
          Two minutes, no IT department required. Here&apos;s exactly where the export button hides.
        </p>

        <div className={`grid gap-8 items-start ${guide.image ? 'lg:grid-cols-5' : 'max-w-2xl mx-auto'}`}>
          {guide.image && (
            <div className="lg:col-span-3">
              <div className="rounded-xl overflow-hidden bg-white shadow-2xl ring-1 ring-white/25">
                <img
                  src={guide.image}
                  alt={`Where to find the export button in ${guide.name}`}
                  className="w-full h-auto block"
                  loading="lazy"
                  data-testid="mc-export-guide-image"
                />
              </div>
            </div>
          )}

          <div className={guide.image ? 'lg:col-span-2' : ''}>
            <ol className="space-y-3 mb-5">
              {guide.steps.map((step, i) => (
                <li key={i} className="flex gap-3 items-start" data-testid={`mc-export-guide-step-${i + 1}`}>
                  <span className="shrink-0 w-6 h-6 rounded-full bg-[#F39C12] text-black text-xs font-black flex items-center justify-center mt-0.5">
                    {i + 1}
                  </span>
                  <span className="text-sm text-white/80 leading-relaxed">{step}</span>
                </li>
              ))}
            </ol>

            <div className="bg-white/5 border border-white/10 rounded p-3 mb-3 flex gap-2 items-start" data-testid="mc-export-guide-file">
              <FileArrowDown size={16} weight="bold" className="text-emerald-400 shrink-0 mt-0.5" />
              <p className="text-xs text-white/70 leading-relaxed">
                <strong className="text-white">What you&apos;ll end up with:</strong> {guide.fileYouGet}.
              </p>
            </div>

            {guide.tip && (
              <div className="bg-[#F39C12]/5 border border-[#F39C12]/25 rounded p-3 flex gap-2 items-start" data-testid="mc-export-guide-tip">
                <Lightbulb size={16} weight="fill" className="text-[#F39C12] shrink-0 mt-0.5" />
                <p className="text-xs text-white/70 leading-relaxed">{guide.tip}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
